<template>
    <select>
        <slot></slot>
    </select>
</template>

<script>
    export default {
        props: ['options', 'value', 'placeholder'],

        watch: {
            value(val) {
                $(this.$el).val(val);
            },
            options(opts) {
                $(this.$el).select2({
                    data: this.mapOptions(opts),
                    minimumResultsForSearch: -1
                })
            }
        },

        methods: {
            mapOptions(options) {
                if (typeof options == 'object') {
                    Object.keys(options).map(function(key, index) {
                        if (typeof options[key].text == 'undefined') {
                            options[key].text = options[key].label;
                        }
                    });
                }
                return options;
            }
        },

        mounted() {
            var vm = this;
            $(this.$el)
                .val(this.value)
                .select2({
                    data: this.mapOptions(this.options),
                    placeholder: this.placeholder,
                    minimumResultsForSearch: -1
                })
                .on('select2:select', function () {
                    vm.$emit('input', $(vm.$el).val())
                })
                .on('select2:unselect', function () {
                    vm.$emit('input', $(vm.$el).val())
                });
        }
    }
</script>